import { DEFAULT_PROFILE_ID, PROFILES, findProfile, type EstimateInput, type ProfileId } from "./materials.ts";

export interface RecommendationContext {
  homeownerKnownProfileId?: ProfileId;
  operatorRecommendedProfileId?: ProfileId;
  positioning?: "value" | "balanced" | "architectural";
}

export interface Recommendation {
  initialProfileId: ProfileId;
  recommendedProfileId: ProfileId;
  source: "operator" | "positioning" | "default";
  reasons: string[];
}

function profileExists(id: string | undefined): id is ProfileId {
  return Boolean(findProfile(id));
}

export function recommendProfile(context: RecommendationContext = {}, _input?: EstimateInput): Recommendation {
  const initialProfileId = profileExists(context.homeownerKnownProfileId)
    ? context.homeownerKnownProfileId
    : DEFAULT_PROFILE_ID;

  if (profileExists(context.operatorRecommendedProfileId)) {
    const product = findProfile(context.operatorRecommendedProfileId)!;
    return {
      initialProfileId,
      recommendedProfileId: product.id,
      source: "operator",
      reasons: product.reasons.slice(0, 3),
    };
  }

  if (context.positioning === "architectural") {
    const product = findProfile("eurostyle_spanlok")!;
    return {
      initialProfileId,
      recommendedProfileId: product.id,
      source: "positioning",
      reasons: product.reasons.slice(0, 3),
    };
  }

  const product = PROFILES.find((profile) => profile.id === DEFAULT_PROFILE_ID)!;
  return {
    initialProfileId,
    recommendedProfileId: product.id,
    source: context.positioning ? "positioning" : "default",
    reasons: product.reasons.slice(0, 3),
  };
}
